const Login = () => import(/* webpackPreload: true, webpackChunkName: "login" */ './Login.vue')

const route = {
  path: 'login',
  name: 'Login',
  component: Login,
  meta: {
    requiresLogin: false,
    requiresCompany: false,
    permissions: []
  }
}

export default {
  route
}
